import React from "react";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { RoutePoint } from "../../models/routes/routePoint";
import { MapService } from "../../models/enums/mapServices";

type Props = {
    isOpen: boolean;
    toggle: () => void;
    routePoints: RoutePoint[];
};

interface MapServiceInfo {
    service: MapService;
    alt: string;
    icon: string;
    generateUrl: (points: RoutePoint[]) => string;
}

const mapServices: MapServiceInfo[] = [
    {
        service: MapService.YANDEX,
        alt: "Яндекс Карты",
        icon: "yandex-map.svg",
        generateUrl: (points: RoutePoint[]) =>
            `https://yandex.ru/maps/?rtext=~${points.map((p) => `${p.latitude || ""},${p.longitude || ""}`).join("~")}&rtt=auto`,
    },
    {
        service: MapService.DGIS,
        alt: "2ГИС",
        icon: "2gis-map.svg",
        generateUrl: (points: RoutePoint[]) =>
            `https://2gis.ru/directions/points/${points.map((p) => `%7C${p.longitude || ""}%2C${p.latitude || ""}`).join("")}`,
    },
    {
        service: MapService.GOOGLE,
        alt: "Google Maps",
        icon: "google-map.svg",
        generateUrl: (points: RoutePoint[]) =>
            `https://www.google.com/maps/dir/Current+Location/${points
                .map((p) => `${p.latitude || ""},${p.longitude || ""}`)
                .join("/")}`,
    },
    {
        service: MapService.YANDEX_NAVIGATOR,
        alt: "Яндекс Навигатор",
        icon: "yandex-navigator.svg",
        generateUrl: (points: RoutePoint[]) => {
            let viaPointNumber = -1;
            return `yandexnavi://build_route_on_map?${points
                .map((p, index) => {
                    switch (index) {
                        case 0:
                            return `lat_from=${p.latitude || ""}&lon_from=${p.longitude || ""}`;
                        case points.length - 1:
                            return `lat_to=${p.latitude || ""}&lon_to=${p.longitude || ""}`;
                        default:
                            viaPointNumber++;
                            return `lat_via_${viaPointNumber}=${p.latitude || ""}&lon_via_${viaPointNumber}=${p.longitude || ""}`;
                    }
                })
                .join("&")}`;
        },
    },
];

const RouteNavigationModal = ({ isOpen, toggle, routePoints }: Props) => (
    <Modal centered isOpen={isOpen} toggle={toggle}>
        <ModalHeader toggle={toggle}>Выберите приложение</ModalHeader>
        <ModalBody>
            <Row>
                {mapServices.map((serviceInfo) => (
                    <Col xs="3" key={serviceInfo.service}>
                        <a
                            href={serviceInfo.generateUrl(routePoints)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex flex-column align-items-center"
                        >
                            <img
                                src={`${process.env.PUBLIC_URL}/media/${serviceInfo.icon}`}
                                alt={serviceInfo.alt}
                                style={{ width: "40px", height: "40px" }}
                            />
                        </a>
                    </Col>
                ))}
            </Row>
        </ModalBody>
    </Modal>
);

export default RouteNavigationModal;
